import { render, staticRenderFns } from "./edit-alipay-data.vue?vue&type=template&id=6872c294"
import script from "./edit-alipay-data.vue?vue&type=script&lang=ts"
export * from "./edit-alipay-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports